import { render, staticRenderFns } from "./StockableItemFixtureDetails.vue?vue&type=template&id=25453fa0&"
import script from "./StockableItemFixtureDetails.vue?vue&type=script&lang=ts&"
export * from "./StockableItemFixtureDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports